import { Router } from 'express';
import * as controller from './users.controller';
import { authMiddleware } from '../../middleware/auth.middleware';
import { requirePermission } from '../../middleware/rbac.middleware';

const router = Router();

// Require authentication for all user routes
router.use(authMiddleware);

// Search needs to be before /:id to prevent "search" being treated as an ID
router.get('/search', controller.search);

// Profiles and Listing
router.get('/', controller.list);
router.get('/:id', controller.getById);
router.get('/username/:username', controller.getByUsername);
router.patch('/me', controller.updateMe);
router.post('/presence/bulk', controller.presenceBulk);

// Admin / User Management endpoints
router.post('/', requirePermission('manage_users'), controller.create);
router.patch('/:id', requirePermission('manage_users'), controller.update);
router.post('/:id/activate', requirePermission('manage_users'), controller.activate);
router.post('/:id/deactivate', requirePermission('manage_users'), controller.deactivate);
router.delete('/:id', requirePermission('manage_users'), controller.destroy);
router.post('/:id/visibility', requirePermission('manage_users'), controller.assignVisibility);

export default router;
